import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { all, spread } from 'axios';

import {
  adminInstance as axios,
  authorizedInstanceNoBase as axiosFullUrl,
} from '~/utils';

import { PseudoStates, PageTitle } from '@cordata/buffet';
import FacilitiesForm from '~/components/Facility/Form';

const FacilitiesDetails = () => {
  const params = useParams();
  const [facility, setFacility] = useState({});
  const [facilityAddresses, setFacilityAddresses] = useState({});
  const [facilityPhones, setFacilityPhones] = useState({});
  const [facilityDistributionLists, setFacilityDistributionLists] = useState([]);
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/facility/${params.facility_id}`)
      .then(fr => all([
        fr,
        axiosFullUrl.get(fr.data.data.relationships.facilityAddresses.related),
        axiosFullUrl.get(fr.data.data.relationships.facilityPhones.related),
        axiosFullUrl.get(fr.data.data.relationships.facilityDistributionLists.related),
      ]))
      .then(spread((fr, ar, pr, dlr) => {
        setFacility(fr.data.data);
        setFacilityAddresses(ar.data.data);
        setFacilityPhones(pr.data.data);
        setFacilityDistributionLists(dlr.data.data);
      }))
      .catch(e => setError(e))
      .then(() => setIsLoading(false));
  }, []);

  return (
    <>

      {!isLoading && !error ? (
        <>
          <PageTitle>{facility.attributes.facilityName}</PageTitle>

          <FacilitiesForm
            facility={facility}
            facilityAddresses={facilityAddresses}
            facilityPhones={facilityPhones}
            facilityDistributionLists={facilityDistributionLists}
            params={params}
          />
        </>
      ) : (
        <PseudoStates
          isLoading={isLoading}
          error={error}
        />
      )}
    </>
  );
};

export default FacilitiesDetails;
